module Client.ReCaptcha
open Fable.Core.JS
open Fable.Core.JsInterop

let initialize (reCaptchaSiteKey : string) =
  let loadScriptByURL (id, url, callback : (unit -> unit)) =
    let isScriptExist = Browser.Dom.document.getElementById(id) <> null
    if not isScriptExist
    then
      let script = Browser.Dom.document.createElement "script"
      script.onload <- (fun _ -> callback())
      script.setAttribute("type", "text/javascript")
      script.setAttribute("src", url)
      script.id <- id
      Browser.Dom.document.body.appendChild(script) |> ignore
    else ()
    if isScriptExist then callback() else ()

  // load the script by passing the URL
  loadScriptByURL("recaptcha-key",sprintf "https://www.google.com/recaptcha/api.js?render=%s" reCaptchaSiteKey, (fun () -> Browser.Dom.console.log("ReCaptcha script loaded!")))


let registerCallBack (reCaptchaSiteKey : string) (action : string) (callBack : (string -> unit))=
  Browser.Dom.window?grecaptcha?ready(fun () ->
    promise {
      let! token = Browser.Dom.window?grecaptcha?execute(reCaptchaSiteKey, {| action = action |})
      callBack token
    }
  )